var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9c06bdd0bbf8cd5e47a274b00cee48c1283517f7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["brokrete-dashboard@brokrete"]={id:"9c06bdd0bbf8cd5e47a274b00cee48c1283517f7"};
      